import { render, staticRenderFns } from "./NotificationAdd.vue?vue&type=template&id=143d000b&scoped=true&"
import script from "./NotificationAdd.vue?vue&type=script&lang=js&"
export * from "./NotificationAdd.vue?vue&type=script&lang=js&"
import style0 from "./NotificationAdd.vue?vue&type=style&index=0&id=143d000b&prod&lang=scss&"
import style2 from "./NotificationAdd.vue?vue&type=style&index=2&id=143d000b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143d000b",
  null
  
)

export default component.exports